import React from 'react'
import { CTATheme, fontGraphik } from '../../utils'
import { CTALink } from '../CTALink'
import { Image } from '../Image'
import { RichText } from '../RichText'
import { TagGroup } from '../TagGroup'
import { Text } from '../Text'
import { IProps } from './index'

import { CardWithImage as CardWithImageDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const CardWithImage: React.FC<IProps> = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <CardWithImageDefault {...props} />
  }
  return <CardWithImageLegacy {...props} />
}

const CardWithImageLegacy: React.FC<IProps> = ({
  title,
  body,
  cta,
  imageRef,
  tags,
  centerAlign,
}: IProps) => {
  const CardContent = (
    <div className="card-wrapper">
      {/* Image */}
      <div className="border-image">
        <Image {...imageRef} borderRadius={20} classNames="card-image" />
      </div>

      {/* Tags */}
      <div className="lower-cell">
        {!!tags && !!tags.length && (
          <div className="tags">
            <TagGroup tagData={tags} />
          </div>
        )}
        {/* Title */}
        {title && (
          <div className="title card-with-image__title">
            <RichText html={title} />
          </div>
        )}

        {/* Body */}
        {body && (
          <div className="body">
            <Text size="body">{body}</Text>
          </div>
        )}

        {/* CTA */}
        {cta && (
          <div className="cta">
            <CTALink {...cta} bgColor={CTATheme.LinkOnlyBlack} arrow />
          </div>
        )}
      </div>
      <style jsx>
        {`
          .card-wrapper {
            display: grid;
            grid-template-rows: [upper] min-content [lower] 1fr;
            grid-row-gap: 24px;
          }

          .border-image {
            overflow: hidden;
            border-radius: 20px;
            margin: ${centerAlign ? '0 auto' : '0'};
          }

          .card-image {
            grid-row: upper;
            width: 100%;
            height: auto;
          }

          .lower-cell {
            grid-row: lower;
            display: block;
            padding-bottom: 16px;
            text-align: ${centerAlign ? 'center' : 'left'};
          }

          .title {
            word-break: break-word;
            margin-bottom: ${body ? '16px' : '10px'};
            font-size: 26px;
            font-family: ${fontGraphik};
            line-height: 1.2;
          }

          .body,
          .tags {
            margin-bottom: 10px;
          }

          .cta {
            display: ${centerAlign ? 'block' : 'inline-block'};
            text-align: ${centerAlign ? 'center' : 'left'};
            padding-bottom: 20px;
          }
        `}
      </style>
      <style jsx global>{`
        .card-with-image__title .rich-text p {
          line-height: 1.4;
        }
      `}</style>
    </div>
  )

  if (cta) {
    return (
      <a
        className="card-link"
        href={cta.url}
        target={cta.newWindow ? '_blank' : ''}
        rel={cta.newWindow ? 'noopener nofollow' : ''}
      >
        {CardContent}
        <style jsx>
          {`
            .card-link {
              display: block;
              color: initial;
            }

            .card-link,
            .card-link:hover {
              text-decoration: none;
            }

            .card-link:hover :global(.cta-link) {
              text-decoration: underline;
            }

            .border-image {
              overflow: hidden;
              border-radius: 20px;
            }
          `}
        </style>
      </a>
    )
  }

  return CardContent
}
